class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => { this.classList.add('animate', 'active'); });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      if (containerToTrapFocusOn && focusElement && typeof trapFocus === 'function') trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden', 'billion-cart-drawer-open');
    document.documentElement.classList.add('billion-cart-drawer-open');
  }

  close() {
    this.classList.remove('active');
    if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden', 'billion-cart-drawer-open');
    document.documentElement.classList.remove('billion-cart-drawer-open');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner')?.classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (sectionElement && parsedState.sections[section.id]) sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}

(function() {
  function defineCartDrawerItems() {
    if (customElements.get('cart-drawer-items')) return true;
    if (typeof CartItems === 'undefined') return false;

    class CartDrawerItems extends CartItems {
      getSectionsToRender() {
        return [
          {
            id: 'CartDrawer',
            section: 'cart-drawer',
            selector: '.drawer__inner'
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section'
          }
        ];
      }
    }

    customElements.define('cart-drawer-items', CartDrawerItems);
    return true;
  }

  function loadCartScript() {
    if (defineCartDrawerItems()) return;

    const currentScript = document.currentScript || Array.from(document.scripts).find((script) => script.src && script.src.includes('cart-drawer.js'));
    const cartScriptUrl = currentScript ? currentScript.src.replace(/cart-drawer\.js(\?.*)?$/, 'cart.js$1') : '';

    if (!cartScriptUrl) return;

    const existingCartScript = Array.from(document.scripts).find((script) => script.src && script.src.includes('/cart.js'));
    if (existingCartScript) {
      existingCartScript.addEventListener('load', defineCartDrawerItems, { once: true });
      window.setTimeout(defineCartDrawerItems, 80);
      return;
    }

    const script = document.createElement('script');
    script.src = cartScriptUrl;
    script.defer = true;
    script.onload = defineCartDrawerItems;
    document.head.appendChild(script);
  }

  loadCartScript();
})();

(function() {
  let requestToken = 0;

  function injectCartPolish() {
    if (document.getElementById('billion-cart-polish-style')) return;

    const style = document.createElement('style');
    style.id = 'billion-cart-polish-style';
    style.textContent = `
      .cart-item.is-updating {
        opacity: .72;
        pointer-events: none;
      }

      .billion-cart-trust-row {
        align-items: stretch !important;
      }

      .billion-cart-trust-item {
        min-height: 82px !important;
        height: 82px !important;
        padding: 10px 6px !important;
        justify-content: center !important;
        gap: 7px !important;
      }

      .billion-cart-trust-item svg {
        width: 21px !important;
        height: 21px !important;
        min-height: 21px !important;
        flex: 0 0 21px !important;
      }

      .billion-cart-trust-item span {
        min-height: 30px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        color: #111827 !important;
        font-size: 11px !important;
        line-height: 1.2 !important;
        font-weight: 500 !important;
        letter-spacing: 0 !important;
        text-align: center !important;
      }
    `;
    document.head.appendChild(style);
  }

  function getLineFromElement(element) {
    const lineElement = element && element.closest('[id^="CartDrawer-Item-"]');
    if (!lineElement) return null;
    const match = lineElement.id.match(/CartDrawer-Item-(\d+)/);
    return match ? Number(match[1]) : null;
  }

  function parseSection(html, selector) {
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    return documentFragment.querySelector(selector);
  }

  function renderCartState(state) {
    if (!state || !state.sections) return;

    const drawerHtml = state.sections['cart-drawer'];
    const drawer = document.getElementById('CartDrawer');
    if (drawer && drawerHtml) {
      const newDrawerInner = parseSection(drawerHtml, '.drawer__inner');
      if (newDrawerInner) drawer.innerHTML = newDrawerInner.innerHTML;
    }

    const cartDrawerHost = document.querySelector('cart-drawer');
    if (cartDrawerHost) cartDrawerHost.classList.toggle('is-empty', state.item_count === 0);

    const iconHtml = state.sections['cart-icon-bubble'];
    const icon = document.getElementById('cart-icon-bubble');
    if (icon && iconHtml) {
      const newIcon = parseSection(iconHtml, '#cart-icon-bubble') || parseSection(iconHtml, '.shopify-section');
      if (newIcon) icon.innerHTML = newIcon.id === 'cart-icon-bubble' ? newIcon.innerHTML : newIcon.innerHTML;
    }

    injectCartPolish();
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: state } }));
  }

  function fallbackFetchConfig() {
    if (typeof fetchConfig === 'function') return fetchConfig();
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    };
  }

  function updateLine(line, quantity, lineItem) {
    if (!line) return;
    const token = ++requestToken;
    if (lineItem) lineItem.classList.add('is-updating');

    const body = JSON.stringify({
      line: line,
      quantity: quantity,
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    });

    return fetch(window.routes ? routes.cart_change_url : '/cart/change.js', { ...fallbackFetchConfig(), body })
      .then((response) => response.text())
      .then((text) => {
        if (token !== requestToken) return;
        const state = JSON.parse(text);
        if (!state.errors) renderCartState(state);
      })
      .catch(() => {
        if (lineItem) lineItem.classList.remove('is-updating');
      });
  }

  function handleQuantityButton(event) {
    const button = event.target.closest('cart-drawer .quantity__button');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const lineItem = button.closest('.cart-item');
    const input = lineItem && lineItem.querySelector('.quantity__input');
    const line = getLineFromElement(button);
    if (!input || !line) return;

    const current = Number(input.value || input.getAttribute('value') || 1);
    const step = Number(input.getAttribute('step') || 1);
    const min = Number(input.getAttribute('min') || 1);
    const max = input.hasAttribute('max') ? Number(input.getAttribute('max')) : null;
    const direction = button.getAttribute('name') === 'minus' ? -1 : 1;
    let nextQuantity = current + (step * direction);

    if (max !== null && !Number.isNaN(max)) nextQuantity = Math.min(nextQuantity, max);
    nextQuantity = Math.max(nextQuantity, min);
    if (nextQuantity === current) return;

    input.value = nextQuantity;
    updateLine(line, nextQuantity, lineItem);
  }

  function handleRemoveButton(event) {
    const remove = event.target.closest('cart-drawer cart-remove-button, cart-drawer .cart-remove-button');
    if (!remove) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const line = Number(remove.dataset.index) || getLineFromElement(remove);
    updateLine(line, 0, remove.closest('.cart-item'));
  }

  function handleQuantityInput(event) {
    const input = event.target.closest('cart-drawer .quantity__input');
    if (!input) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const line = Number(input.dataset.index) || getLineFromElement(input);
    const quantity = Math.max(Number(input.value || 1), Number(input.getAttribute('min') || 1));
    input.value = quantity;
    updateLine(line, quantity, input.closest('.cart-item'));
  }

  function initFastCartControls() {
    injectCartPolish();
    if (document.documentElement.dataset.billionFastCartControls === 'true') return;
    document.documentElement.dataset.billionFastCartControls = 'true';

    document.addEventListener('click', handleQuantityButton, true);
    document.addEventListener('click', handleRemoveButton, true);
    document.addEventListener('change', handleQuantityInput, true);
    document.addEventListener('shopify:section:load', injectCartPolish);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFastCartControls);
  } else {
    initFastCartControls();
  }
})();
